import { RoleEnum } from '../types/common.type';
import { t } from '../i18n/util';

export const userLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 6 },
    lg: { span: 6 },
    xl: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 18 },
    lg: { span: 18 },
    xl: { span: 18 }
  }
};

export const formItemLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 24 },
    lg: { span: 24 },
    xl: { span: 24 }
  }
};

export const formItemStyle = {
  width: '100%'
};

export const authLayout = {
  labelCol: {},
  wrapperCol: {}
};

export const profileRoleItems = [
  { id: RoleEnum.OWNER, name: t('labelOwner') },
  { id: RoleEnum.MANAGER, name: t('labelAdmin') },
  { id: RoleEnum.EMPLOYEE, name: t('labelViewer') }
];

export const userRoleName = {
  [RoleEnum.OWNER]: t('labelOwner'),
  [RoleEnum.MANAGER]: t('labelAdmin'),
  [RoleEnum.EMPLOYEE]: t('labelViewer')
};
